import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "@/components/ThemeProvider";

// The desktop app renders at a 15px base (Caleb, 2026-09-29). Pinned rather
// than inherited because Chrome's font setting varies per person (his is 18px),
// and every size in the app is rem-based. See client/src/baseSize.test.ts.
document.documentElement.classList.add("desktop-app");

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="system" storageKey="ftc-crm-theme">
    <App />
  </ThemeProvider>
);
